/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {getImpl} from '../src/Global';
import Metrics from './Metrics';

/**
 * Defines the metrics API.
 */
export interface MetricsApi {
  /**
   * Creates a metrics instance for the specified component to log entries and events.
   * @param name The name of the component.
   */
  create(name: string): Readonly<Metrics>;
}

const api: MetricsApi = {
  create: name => {
    return getImpl('metrics').create(name);
  }
};

export default api;
export {
  Metrics
};
